// extracted by mini-css-extract-plugin
export var divider = "styles-module--divider--952ae";
export var nav = "styles-module--nav--615e6";